export const NexusRoutes = {
  RentalListings: '/leasing/rentals/',
  RentalDetails: '/leasing/rentals/:rentalId/',
  ScheduleShowing: '/leasing/showings/',
  LeadsCreate: '/leasing/leads/',
  RentalAvailableTimes: '/leasing/rentals/:rentalId/available_times/',
  ShowingCancel: '/leasing/showings/:showingId/cancel/',
  RentalAgentProfile: '/leasing/rental_agents/profile/',
};
